import React, { Component } from 'react';
import OLSelect from 'ol/interaction/select';

import ol_condition from 'ol/events/condition';

class Select extends Component {
  constructor(props) {
    super(props);

    const { mapInstance, active, condition, addCondition, removeCondition, toggleCondition, filter, features, onSelect } = this.props;

    this.select = new OLSelect({
      // condition: condition || ol_condition.click,
      // addCondition: addCondition || ol_condition.click,
      //removeCondition: removeCondition || ol_condition.never,
      //toggleCondition: toggleCondition || ol_condition.click,
      hitTolerance: 5,
      features,
      filter
    });
    this.select.setActive(active)
    this.select.on('select', this.props.onSelect)
    mapInstance.addInteraction(this.select);
  }

  componentDidMount() {
    //const { mapInstance, onAdd, onRemove } = this.props;
  }

  componentWillReceiveProps(newProps) {
    if(newProps.active !== this.props.active) {
      this.select.setActive(newProps.active);
    }
  }

  componentWillUnmount() {
    const { mapInstance } = this.props;
    mapInstance.removeInteraction(this.select);
  }

  render() {
    return null;
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/ol/interactions/Select.js